import { jsx as _jsx } from "react/jsx-runtime";
import { Emoji } from './icons/emoji';
import { Number } from './icons/number';
import { Star } from './icons/star';
export const SingleIcon = ({ score, scoreIconStyle, size, }) => {
    if (0 > score || score > 5) {
        return null;
    }
    const props = { score, size, isSelected: true };
    switch (scoreIconStyle) {
        case 'stars':
            return _jsx(Star, Object.assign({}, props));
        case 'numbers':
            return _jsx(Number, Object.assign({}, props));
        case 'emojis':
        default:
            return _jsx(Emoji, Object.assign({}, props));
    }
};
